import {gql} from '@apollo/client'

export const GET_APPOINTMENTS_BY_RANGE = gql`
  query allAppointments($date_Gte: DateTime, $date_Lte: DateTime, $assignedTo_Id: Float) {
    allAppointments(date_Gte: $date_Gte, date_Lte: $date_Lte, assignedTo_Id: $assignedTo_Id) {
      edges {
        node {
          id
          tittle
          date
          meetingLocation
          typeAppointment
          comment
          assignedTo {
            id
            firstName
            lastName
          }
          creditTo {
            id
            firstName
            lastName
          }
          lead {
            id
            name
            stagePipeline {
              name
              pipeline {
                name
              }
            }
          }
        }
      }
    }
  }
`
